import { render, staticRenderFns } from "./tableService.vue?vue&type=template&id=61a7f375&scoped=true&"
import script from "./tableService.vue?vue&type=script&lang=js&"
export * from "./tableService.vue?vue&type=script&lang=js&"
import style0 from "./tableService.vue?vue&type=style&index=0&id=61a7f375&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a7f375",
  null
  
)

export default component.exports